(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.footer-cookie-settings');
    if (!trigger) return;

    event.preventDefault();

    if (window.privacyBanner && typeof privacyBanner.showPreferences === 'function') {
      privacyBanner.showPreferences().then(function () {
        console.log('preferences modal opened');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stockists"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.stockists__country-name, .stockists__online-item-name').forEach((button) => {
    button.addEventListener('click', () => {
      const container = button.nextElementSibling;
      const isOpen = container.classList.contains('is-active');

      button.classList.toggle('is-active', !isOpen);
      container.classList.toggle('is-active', !isOpen);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
